import React from "react";

const PageLoader = ({ isFading }) => {
  const styles = `
    .page-loader-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      transition: opacity 0.6s ease;
    }

    .page-loader-overlay.fade-out {
      opacity: 0;
      pointer-events: none;
    }

    .page-loader-grid-wrapper {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(3, 1fr);
      gap: 5px;
      width: 60px;
      height: 60px;
      margin-bottom: 20px;
    }

    .page-loader-square {
      width: 100%;
      height: 100%;
      background-color: #f97316;
      transform: scale(0);
      border-radius: 4px;
      animation: page-grid-pulse 1.8s infinite ease-in-out;
    }

    .page-loader-square:nth-child(1) { animation-delay: 0.0s; }
    .page-loader-square:nth-child(2) { animation-delay: 0.2s; }
    .page-loader-square:nth-child(3) { animation-delay: 0.4s; }
    .page-loader-square:nth-child(4) { animation-delay: 0.2s; }
    .page-loader-square:nth-child(5) { animation-delay: 0.4s; }
    .page-loader-square:nth-child(6) { animation-delay: 0.6s; }
    .page-loader-square:nth-child(7) { animation-delay: 0.4s; }
    .page-loader-square:nth-child(8) { animation-delay: 0.6s; }
    .page-loader-square:nth-child(9) { animation-delay: 0.8s; }

    .page-loader-text {
      margin-top: 16px;
      font-size: 1.125rem;
      color: #6b7280;
      font-family: 'Arial', sans-serif;
      animation: page-text-pulse 1.5s infinite ease-in-out;
    }

    @keyframes page-grid-pulse {
      0%, 100% { transform: scale(0); opacity: 0; }
      40%       { transform: scale(1); opacity: 1; }
      80%       { transform: scale(0); opacity: 0; }
    }

    @keyframes page-text-pulse {
      0%   { opacity: 0.8; }
      50%  { opacity: 0.4; }
      100% { opacity: 0.8; }
    }
  `;

  return (
    <div className={`page-loader-overlay ${isFading ? "fade-out" : ""}`}>
      <style>{styles}</style>

      <div className="page-loader-grid-wrapper">
        {[...Array(9)].map((_, index) => (
          <div key={index} className="page-loader-square"></div>
        ))}
      </div>

      <p className="page-loader-text">Loading...</p>
    </div>
  );
};

export default PageLoader;